<template>
    <section class="dd-m-banner dd-m-banner--headline">
        <h2>{{ getTranslateString('Discover your ideal fragrance instantly') }}</h2>
    </section>
</template>

<script>
export default {
    name: 'banner-headline'
}
</script>


// WEBPACK FOOTER //
// resources/site/js/components/banners/banner-headline.vue